import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Core version + navigation, pagination modules
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode, Controller, EffectFade, EffectCube, EffectCreative, Mousewheel, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-cube';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-cards';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, FreeMode,Controller,EffectFade, EffectCube, EffectCreative, Mousewheel, Keyboard]);

// Export for global use if needed
window.Swiper = Swiper

// Lazyload
import lazyLoadInit from '../../../../general/js/lazy';
lazyLoadInit();

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// fslightbox
import FsLightbox from "fslightbox";

import Plyr from 'plyr';

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const setupApp = ()=>
{
    const player = new Plyr('#player', {
        ratio: '16:9'
    });

    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const heroDescSwiperOptions ={
        modules: [Navigation, Pagination, Keyboard, EffectFade, Autoplay, Controller],
        slidesPerView: 1,
        autoplay : true,
        // loop: true,
        // effect: 'fade',
        // fadeEffect: {
        //     crossFade: true
        // },
        navigation: {
            prevEl: '.hero-swiper-button-next',
            nextEl: '.hero-swiper-button-prev',
            disabledClass: 'text-gray-200 scale-90 border-none transition-all duration-300 ease-in-out',
        },
    };

    const heroImageSwiperOptions = {
        modules: [EffectFade, Autoplay],
        // autoplay : true,
        slidesPerView: 1,
        // loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        allowTouchMove: false
        // navigation: {
        //     nextEl: '.hero-swiper-button-next',
        //     prevEl: '.hero-swiper-button-prev',
        //   },
    };

    const heroDescSwiper = new Swiper('.hero-description-swiper', heroDescSwiperOptions);
    const heroImagesSwiper = new Swiper('.hero-images-swiper', heroImageSwiperOptions);
    heroDescSwiper.controller.control = heroImagesSwiper;

    const qualitiesSwiperOptions = {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1.1,
        spaceBetween:30,
        centeredSlidesBounds:true,
        centeredSlides:true,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 2.2,
            },
            1280:{
                enabled:false,
                slidesPerView: 4,
                slidesOffsetAfter:0,
                spaceBetween:20,
                centeredSlides: true,
                centeredSlidesBounds: true,
                loop:false,
                clickable:false,
                allowSlideNext:false,
                allowSlidePrev:false,
            },
        }

    };
    const qualitiesSwiper = new Swiper('#qualities-swiper', qualitiesSwiperOptions);

    const courseSwiper = new Swiper('#course-swiper', {
        breakpoints: {
            320: {
                slidesPerView: 1.3,
                spaceBetween: 20
            },
            480: {
                slidesPerView: 2.2,
                spaceBetween: 20
            },
            640: {
                slidesPerView: 2.5,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 20
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            // 1536: {
            //     slidesPerView: 4,
            //     spaceBetween: 20
            // }
        }
    });

    const nextCourseSlideButton = document.querySelectorAll('.course-next-slide');
    const prevCourseSlideButton = document.querySelectorAll('.course-prev-slide');

    nextCourseSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            courseSwiper.slideNext();
        });
    });
    prevCourseSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            courseSwiper.slidePrev();
        });
    });

    const shopSwiper = new Swiper('#shop-swiper', {
        breakpoints: {
            320: {
                slidesPerView: 1.3,
                spaceBetween: 20
            },
            480: {
                slidesPerView: 1.3,
                spaceBetween: 20
            },
            640: {
                slidesPerView: 2.3,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1280: {
                slidesPerView: 3.5,
                spaceBetween: 20
            },
            // 1440: {
            //     slidesPerView: 4.5,
            //     spaceBetween: 20
            // }
        }
    });

    const nextShopSlideButton = document.querySelectorAll('.shop-next-slide');
    const prevShopSlideButton = document.querySelectorAll('.shop-prev-slide');

    nextShopSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            shopSwiper.slideNext();
        });
    });
    prevShopSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            shopSwiper.slidePrev();
        });
    });


    const gallerySwiper = new Swiper('#gallery-swiper', {
        breakpoints: {
            320: {
                slidesPerView: 1.3,
                spaceBetween: 20
            },
            480: {
                slidesPerView: 1.3,
                spaceBetween: 20
            },
            640: {
                slidesPerView: 2.3,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 3.5,
                spaceBetween: 20
            },
            1440: {
                slidesPerView: 4.5,
                spaceBetween: 20
            }
        }
    });

    const nextGallerySlideButton = document.querySelectorAll('.gallery-next-slide');
    const prevGallerySlideButton = document.querySelectorAll('.gallery-prev-slide');

    nextGallerySlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            gallerySwiper.slideNext();
        });
    });
    prevGallerySlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            gallerySwiper.slidePrev();
        });
    });


    const blogSwiper = new Swiper('#blog-swiper', {
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 20
            },
            480: {
                slidesPerView: 2.2,
                spaceBetween: 20
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1440: {
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });

    const nextBlogSlideButton = document.querySelectorAll('.blog-next-slide');
    const prevBlogSlideButton = document.querySelectorAll('.blog-prev-slide');

    nextBlogSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            blogSwiper.slideNext();
        });
    });
    prevBlogSlideButton.forEach(function (button, index) {
        button.addEventListener('click', function () {
            blogSwiper.slidePrev();
        });
    });


    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });


    const navbar = document.querySelector('#navbar');
    const scrollThreshold = 40; // Change this to the number of pixels you want to scroll before changing the height
    let prevScrollPosition = window.scrollY;

    window.addEventListener('scroll', () => {
        const scrollPosition = window.scrollY;

        if (scrollPosition > scrollThreshold ) { //&& scrollPosition > prevScrollPosition
            navbar.classList.add('sticky_nav');
        } else {
            navbar.classList.remove('sticky_nav');
        }

        prevScrollPosition = scrollPosition;
    });


};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})
